
// const baseurl = 'http://192.168.31.221:44375/api'// api接口

// 服务器
// const baseurl = 'http://118.190.216.205:8011/api'

// 美国服务器
const baseurl = 'http://149.28.43.151:8002/api'

export default {
  baseurl
}



// WEBPACK FOOTER //
// ./src/api/basepath.js